import type { ReactNode } from "react";

import { Sheet } from "@heroui-pro/react";

/** A side sheet for looking at one record: a title, an optional action beside it, and a scrolling body with no footer. */
export function ViewSheet({
  isOpen,
  onClose,
  title,
  description,
  action,
  children,
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  /** Sits at the end of the header, left of the close button (for example Refresh). */
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Sheet
      isDetached
      isOpen={isOpen}
      placement="right"
      onOpenChange={(open) => !open && onClose()}
    >
      <Sheet.Backdrop className="z-0">
        <Sheet.Content className="w-full max-w-2xl">
          <Sheet.Dialog>
            <div className="flex h-full min-h-0 flex-col">
              <Sheet.CloseTrigger />
              <Sheet.Header className="flex-row! items-start justify-between gap-4 pe-12">
                <div className="flex min-w-0 flex-col">
                  <Sheet.Heading>{title}</Sheet.Heading>
                  {description ? (
                    <p className="text-muted truncate text-sm">{description}</p>
                  ) : null}
                </div>
                {action}
              </Sheet.Header>
              <Sheet.Body className="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto">
                {children}
              </Sheet.Body>
            </div>
          </Sheet.Dialog>
        </Sheet.Content>
      </Sheet.Backdrop>
    </Sheet>
  );
}
